import { wallMultipleIndex, plinkoDistancesX, plinkoDistancesY } from '../../../config'
import PlinkoGraphicBase from './Base'

interface WallConstructor {
  width: number
  startX: number
  startY: number
  endX: number
  endY: number
  row: number
}

class Wall extends PlinkoGraphicBase {
  width: number
  height: number

  constructor(Matter: any, paramater: WallConstructor) {
    const { width, startX, startY, endX, endY, row } = paramater
    const options = {
      restitution: 1,
      friction: 0,
      isStatic: true,
    }

    // using the Euclidean distance formula
    const height = Math.sqrt((startX - endX) * (startX - endX) + (startY - endY) * (startY - endY))
    const body = Matter.Bodies.rectangle(startX, startY, width, height, options)

    super(Matter, body)

    this.width = width
    this.height = height

    const x = wallMultipleIndex[row] * (plinkoDistancesX[row] / 2)
    const y = wallMultipleIndex[row] * plinkoDistancesY[row]

    if (startX > endX) {
      Matter.Body.rotate(this.body, Math.asin((startX - endX) / this.height))
      Matter.Body.translate(this.body, {
        x: -1 * x,
        y,
      })
    } else {
      Matter.Body.rotate(this.body, -1 * Math.asin((endX - startX) / this.height))
      Matter.Body.translate(this.body, {
        x,
        y,
      })
    }
  }

  display(p5: any) {
    const pos = this.body.position
    const angle = this.body.angle

    p5.push()
    p5.translate(pos.x, pos.y)
    p5.rotate(angle)

    p5.fill(255, 101, 3)
    p5.rect(-this.width / 2, -this.height / 2, this.width, this.height)
    p5.pop()
  }
}

export default Wall
